/**
 * @license
 * Copyright (c) 2020 ForgeRock. All rights reserved.
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { localizeDefaultValidationMessages } from './localizeDefaultValidationMessages';

Vue.use(VueI18n);

function loadLocaleMessages () {
    const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i),
        messages = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}

const navigator = window.navigator;
const languages = navigator.languages || navigator.language || navigator.browserLanguage || navigator.userLanguage;
const urlParams = new URLSearchParams();
for (const src of [new URLSearchParams(window.location.search), new URLSearchParams(window.location.hash.split('?')[1] || window.location.search.split('?')[1] || window.location.search)]) {
    for (const [key, value] of src.entries()) {
        if (key === 'locale' && value && !['null', 'undefined'].includes(value)) {
            urlParams.set('locale', value.replaceAll('/', ''));
        }
    }
}
const urlLocale = urlParams.get('locale');
let fallbackLocale = '';
if (urlLocale === 'zh' || urlLocale === 'zh/') {
    fallbackLocale = 'zh';
}
const i18n = new VueI18n({
    locale: urlLocale || process.env.VUE_APP_I18N_LOCALE || languages[0] || 'en',
    fallbackLocale: fallbackLocale || process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: loadLocaleMessages()
});

localizeDefaultValidationMessages(i18n);

export default i18n;
